<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col lg="12" class="ml-auto">
      <notifications group="error" position="top center" class="mt-1" />
      <notifications group="success" position="top left" class="mt-1" />
      <notifications group="info" position="top left" class="mt-1" />
      <notifications group="warn" position="top left" class="mt-1" />
      <loading v-if="vLoading" />
      <b-card-group deck>
        <b-card
          bg-variant="primary"
          text-variant="white"
          v-b-tooltip="{
            title: 'برای ورود کلیک نمایید',
            placement: 'bottom',
            variant: 'primary',
          }"
          style="cursor: pointer"
          @click="gotoCustomers()"
        >
          <v-row>
            <v-col cols="8">
              <h3>
                <h2>
                  <b-badge variant="defualt">{{
                    dashboard.customersNumber
                  }}</b-badge>
                </h2>
                <b-card-text>
                  مشتری‌های سازمان
                  <br />
                  <br />
                </b-card-text>
              </h3>
            </v-col>
            <v-col cols="4">
              <h3 class="text-left">
                <i class="fa fa-object-ungroup"></i>
              </h3>
            </v-col>
          </v-row>
        </b-card>

        <b-card
          bg-variant="success"
          text-variant="white"
          v-b-tooltip="{
            title: 'برای ورود کلیک نمایید',
            placement: 'bottom',
            variant: 'success',
          }"
          style="cursor: pointer"
          @click="gotoOrders()"
        >
          <v-row>
            <v-col cols="8">
              <h3>
                <h2>
                  <b-badge variant="defualt">{{
                    dashboard.ordersNumber
                  }}</b-badge>
                </h2>
                <b-card-text>
                  درخواست‌های سازمان
                  <br />
                  <br />
                </b-card-text>
              </h3>
            </v-col>
            <v-col cols>
              <h3 class="text-left">
                <i class="fa fa-hourglass"></i>
              </h3>
            </v-col>
          </v-row>
        </b-card>
        <b-card
          v-if="role == 'secretary'"
          bg-variant="warning"
          text-variant="white"
          v-b-tooltip="{
            title: 'برای ورود کلیک نمایید',
            placement: 'bottom',
            variant: 'warning',
          }"
          style="cursor: pointer"
          @click="gotoNewOrder()"
        >
          <v-row>
            <v-col cols="10">
              <h2>
                <i class="fa fa-plus"></i>
              </h2>
              <h3>
                <b-card-text>
                  ثبت استعلام جدید
                  <br />
                  <br />
                </b-card-text>
              </h3>
            </v-col>
            <v-col cols="2">
              <h3 class="text-left">
                <i class="fa fa-edit"></i>
              </h3>
            </v-col>
          </v-row>
        </b-card>
      </b-card-group>
      <br />
    </v-col>

    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <h4>استعلام‌های ثبت شده امروز ({{dashboard.orders ? dashboard.orders.length: "-"}})</h4>
      </template>
      <v-row>
        <v-col cols="8"></v-col>
        <v-col cols="2">
          <div class="text-left">
            <v-btn
              class="darkGreen-mainBtn white--text"
              depressed
              @click="$refs.activeTable.$el.click()"
              :disabled="!dashboard.orders.length"
            >
              <v-icon class="me-1"> mdi-file-excel-outline </v-icon>
              خروجی اکسل
            </v-btn>
          </div>
          <vue-excel-xlsx
            class="darkGreen-mainBtn white--text border"
            ref="activeTable"
            :data="dashboard.orders"
            :columns="ExcelFields"
            :file-name="`استعلام‌های ثبت شده امروز`"
            :sheet-name="`استعلام‌های ثبت شده امروز`"
          ></vue-excel-xlsx>
        </v-col>
        <v-col cols="2">
          <v-btn
            @click="printReceipt"
            :disabled="gettingReceipt || !dashboard.orders.length"
            class="white--text darkRed-mainBtn float-end"
            style="width: 135px; height: 35px;"
            depressed
          >
            <v-icon class="me-1">mdi-printer </v-icon>
            پرینت
          </v-btn>
        </v-col>
      </v-row>
      <b-table
        v-if="dashboard.orders && dashboard.orders.length"
        responsive
        show-empty
        :items="dashboard.orders"
        :fields="fields"
        empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
        empty-text="رکوردی برای نمایش وجود ندارد"
        striped
        :busy="isBusy"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>

        <template v-slot:cell(progress)="data">
          <b-progress
            :value="data.item.progress"
            variant="success"
            :striped="striped"
            show-progress
            animated
          ></b-progress>
        </template>
        <template v-slot:cell(operation)="data">
          <div style="text-align: center; vertical-align: middle">
            <b-btn
              variant="success"
              class="mr-1"
              @click="showModalFollow(data.item)"
              >ثبت پیگیری</b-btn
            >
          </div>
        </template>
        <template v-slot:cell(code)="data">
          <div style="text-align: center; vertical-align: middle">
            <a :href="'/' + role + '/order/' + data.item.id" target="_blank">{{
              data.item.code
            }}</a>
          </div>
        </template>
        <template v-slot:cell(customerName)="data">
          <a :href="'/' + role + '/customerProfile/' + data.item.customerId">{{
            data.item.customerName
          }}</a>
        </template>
        <div slot="table-busy" class="text-center text-danger my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <v-card v-else>
        <v-card-text class="py-2 px-2">
          <v-container>
            <p style="text-align:center; font-size: 15px; font-weight: bold; margin-top: 10px;">امروز استعلامی ثبت نشده است.</p>
          </v-container>
        </v-card-text>
      </v-card>
      <br />
    </b-card>

    <v-dialog v-model="followDialog" max-width="600px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>توضیحات برای پرونده استعلام {{ currentOrder.code }}</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container>
            <p>
              همکار گرامی لطفا توضیحات پیگیری خود و همچنین فایل مربوطه را (در
              صورت وجود) وارد کنید
            </p>
            <div class="mb-2 item-ckeditor">
              <ckeditor
                v-model="content"
                :editor="editor"
                  :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
            <b-form-group label="بارگذاری فایل:">
              <b-form-file
                :state="Boolean(file)"
                @input="upload(file)"
                v-model="file"
                browse-text="آپلود"
                placeholder="فایل مربوطه را آپلود کنید"
                accept="*"
              ></b-form-file>
            </b-form-group>
            <br />
            <b-progress
              v-if="myFile.showProgress"
              :value="myFile.uploadPercentage"
              :max="max"
              show-progress
              :animated="myFile.striped"
              :variant="myFile.variant"
            ></b-progress>
            <v-row>
              <br />
              <div v-if="myFile.isUploaded" color="green" class="mt-3">
                فایل با موفقیت آپلود شد.
              </div>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeModalFollow()">
            لغو
          </v-btn>
          <v-btn color="primary" @click="submitFollowing()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-show="false" id="printTable">
      <h3>استعلام‌های ثبت شده امروز</h3>
      <b-table :items="dashboard.orders" :fields="printfields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../../variables";
import router from "../../router";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import BarChart from "/src/components/charts/BarExample.vue";
import PieChart from "/src/components/charts/PieExample.vue";
export default {
  components: {
    CKEditor,
    BarChart,
    PieChart,
  },
  data: function () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: 'fa',
        contentsLangDirection: 'rtl',
      },
      guide: false,
      showProgress: false,
      uploadButDisable: false,
      gettingReceipt: false,
      printInvoice: {},
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      isBusy: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      uploadedFiles: [],
      content: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      dashboard: [],
      fields: [
        // { key: 'subject', label: 'عنوان استعلام' },
        { key: "customerName", label: "نام مشتری" },
        { key: "code", label: "کد استعلام" },
        { key: "originalRequestId", label: "شماره درخواست مشتری" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      printfields: [
        { key: "customerName", label: "نام مشتری" },
        { key: "code", label: "کد استعلام" },
        { key: "originalRequestId", label: "شماره درخواست مشتری" },
        { key: "status", label: "وضعیت" },
      ],
      ExcelFields: [
        { field: "customerName", label: "نام مشتری" },
        { field: "code", label: "کد استعلام" },
        { field: "originalRequestId", label: "شماره درخواست مشتری" },
        { field: "status", label: "وضعیت" },
      ],
      selected: ["step1"],
      options: [
        { text: "مرحله 1", value: "step1" },
        { text: "مرحله 2", value: "step2" },
        { text: "مرحله3 ", value: "step3" },
      ],

      selectedTime: "on",
      customer_count: "-",
      order_count: "-",
      userName: "",
      name: "",
      gettingReceip: false,
      striped: true,
      currentOrder: "",
      role: "",
      followDialog: false,
      dataBar: {},
      optionsBar: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "تعداد استعلام در هر ماه",
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.fetchMonthData,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "تعداد استعلام در هر ماه",
                fontFamily: "iransans",
              },
              ticks: {
                min: 0,
                fontFamily: "iransans",
                stepSize: 50,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "سال و ماه",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              },
            },
          ],
        },
        legend: {
          display: false,
          position: "bottom",
          labels: {
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
      barGlobalColor: "148,103,189",
      pieGlobalColor: "97, 181, 70",
      pieGlobalColor1: [97, 181, 70],
      pieGlobalColor2: [96, 146, 205],
      dataPie: {},
      optionsPie: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "استعلام‌ها به تفکیک وضعیت",
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          usePointStyle: true,
          position: "bottom",
          labels: {
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
      loaded: false,
    };
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },

    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/user/dashboard",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          setTimeout(() => {
            this.printReceipt();
          }, 400);
        })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title> </title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
    showDashboard() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/user/dashboard",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.dashboard = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    showModalFollow(order) {
      this.currentOrder = order;
      this.followDialog = true;
    },
    closeModalFollow() {
      this.currentOrder = {};
      this.followDialog = false;
    },
    submitFollowing() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/attachFile",
        {
          orderId: this.currentOrder.id,
          file: JSON.stringify(this.uploadedFiles),
          note: this.content,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.followDialog = false;
            this.uploadedFiles = [];
            this.file = [];
            this.myFile = new Object({
              uploadPercentage: 0,
            });
            (this.content = ""),
              this.toast("پیگیری با موفقیت به استعلام اضافه گردید", "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    gotoCustomers() {
      router.push("/" + this.role + "/customerManagement");
    },
    gotoOrders() {
      router.push("/" + this.role + "/orders");
    },
    gotoNewOrder() {
      router.push("/" + this.role + "/newOrder");
    },
    upload(file) {
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();
      formData.append(file.name, file);

      Axios.post(this.baseUrl + "/ppkpms/uploads/private", formData, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
        onUploadProgress: ((progressEvent) => {
          this.myFile.uploadPercentage =
            Math.round((progressEvent.loaded * 100) / progressEvent.total) - 1;
        }).bind(this),
      })
        .then((d) => {
          if (d.status == 200) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            this.uploadedFiles = d.data[0];
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    getChartData() {
      this.loaded = false;
      Axios.post(
        this.baseUrl + "/ppkpms/user/analyticDashboard",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.dataBar = res.data.orderPermonths;
            var barMaximum = Math.max(...this.dataBar.datasets[0].data);
            this.dataBar.datasets[0].backgroundColor = [];
            this.dataBar.datasets[0].data.forEach((data, index) => {
              this.dataBar.datasets[0].backgroundColor[index] =
                "rgba(" + this.barGlobalColor + "," + data / barMaximum + ")";
            });

            this.dataPie = res.data.statusNumbers;
            var pieMaximum = Math.max(...this.dataPie.datasets[0].data);
            var pieCount = this.dataPie.datasets[0].data.length;
            this.dataPie.datasets[0].backgroundColor = [];
            this.dataPie.datasets[0].data.forEach((data, index) => {
              this.dataPie.labels[index] += " (" + data + ")";

              //   this.dataPie.datasets[0].backgroundColor[index] =
              //     "rgba(" + this.pieGlobalColor + "," + data / pieMaximum + ")";

              // random colors
              // var r = Math.floor(Math.random() * 255);
              // var g = Math.floor(Math.random() * 255);
              // var b = Math.floor(Math.random() * 255);
              // this.dataPie.datasets[0].backgroundColor[index] =
              //   "rgb(" + r + "," + g + "," + b + ")";

              // gradiential colors
              this.dataPie.datasets[0].backgroundColor[index] =
                "rgb(" +
                parseInt(
                  (this.pieGlobalColor1[0] * index +
                    this.pieGlobalColor2[0] * (pieCount - index)) /
                    pieCount
                ) +
                "," +
                parseInt(
                  (this.pieGlobalColor1[1] * index +
                    this.pieGlobalColor2[1] * (pieCount - index)) /
                    pieCount
                ) +
                "," +
                parseInt(
                  (this.pieGlobalColor1[2] * index +
                    this.pieGlobalColor2[2] * (pieCount - index)) /
                    pieCount
                ) +
                ")";
            });

            this.loaded = true;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    sortMyChart(type) {
      this.loaded = false;
      let myData = this.dataBar;
      console.log(myData.datasets.filter((x) => x.label == type));
      let filteredBar = myData.datasets.filter((x) => x.label == type)[0].data;
      filteredBar = filteredBar.map((x, index) => {
        return {
          value: x,
          index: index,
        };
      });
      filteredBar = filteredBar.sort((a, b) => a.value - b.value);
      let finalIndex = filteredBar.map((x) => x.index);

      let dataset0 = [];
      let dataset1 = [];
      let dataLabels = [];

      finalIndex.forEach((final, index) => {
        dataset0[index] = this.dataBar.datasets[0].data[final];
        dataset1[index] = this.dataBar.datasets[1].data[final];
        dataLabels[index] = this.dataBar.labels[final];
      });

      myData.datasets[0].data = dataset0;
      myData.datasets[1].data = dataset1;
      myData.labels = dataLabels;

      this.dataBar = myData;

      setTimeout(() => {
        this.loaded = true;
      }, 500);
    },
  },

  mounted() {
    this.showDashboard();
    // this.getChartData();
    this.role = window.localStorage.getItem("role");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
